<template>
    <section class="o-guide-sidebar-otg">
        <OItemDetailsOtg
            :item-id="itemId"
            class="item-details"
        />
        <OSmsQrOtg
            :view="view"
            :itemId="itemId"
            class="qr-generator"
        />
        <OPathStepsOtg
            :view="view"
            :itemId="itemId"
            class="path-steps-otg"
        />
    </section>
</template>

<script>
import OSmsQrOtg from '../../organisms/o-sms-qr-otg';
import OPathStepsOtg from '../../organisms/o-path-steps-otg';
import OItemDetailsOtg from '../../organisms/o-item-details-otg';

import { EVENTS } from "../../../utils/constants/bus-events-constants";

export default {
    name: 'OGuideSidebarOtg',
    components: {
        OSmsQrOtg,
        OPathStepsOtg,
        OItemDetailsOtg
    },
    props: {
        view: {
            type: String,
            default: ''
        }
    },
    computed: {
        itemId() {
            return Number(this.$route.params.itemId) || 0;
        }
    },
    mounted() {
        this.closeModals();
    },
    methods: {
        closeModals() {
            this.$bus.$emit(EVENTS.MODALS.OFF_MODAL, false);
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />